import { axios } from "@Root/API";

export const getStudiesModuleCostCentre = id => {
  return axios.get(`cost-centre-module/${id}`);
};
